<template>
  <div
    class="flex w-full bg-white h-screen overflow-y-auto items-start make-items-center"
  >
    <!-- From Column -->
    <div
      class="w-full sm:w-full lg:w-1/2 items-center flex justify-center p-8 md:p-16 h-full select-none"
    >
      <div
        class="max-w-md mx-auto w-full space-y-12 animate-in fade-in slide-in-from-bottom-4 duration-700"
      >
        <div
          class="flex flex-col sm:flex-row items-center justify-center md:justify-between"
        >
          <img :src="logo.url" class="h-9 w-auto" v-if="logo" />
          <span
            class="border-transparent h-4 w-0 border-r sm:h-10 sm:border-brand-ash mx-3"
          ></span>
          <span
            class="text-base md:text-xl font-semibold text-black tracking-tight self-center"
          >
            Sign-in Link Expired
          </span>
        </div>

        <div class="w-full space-y-6">
          <div
            class="bg-gray-50 border border-gray-100 rounded-2xl p-8 text-center space-y-6 shadow-sm relative overflow-hidden"
          >
            <div
              class="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-red-400 opacity-5 rounded-full blur-2xl"
            ></div>

            <div class="flex justify-center">
              <div
                class="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center text-red-500 border border-red-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>

            <div class="space-y-2">
              <p class="block font-light text-brand-secondary leading-relaxed">
                The magic sign-in link sent to
                <span class="font-semibold text-black">"{{ email }}"</span> has
                expired.
              </p>
              <p class="text-sm text-brand-body text-opacity-70">
                Magic links are valid for 10 minutes and can only be used once.
              </p>
            </div>
          </div>

          <div class="flex flex-col gap-4">
            <Button
              title="Resend Magic Link"
              type="button"
              :loader="user.magicLinkLoader"
              @click="resendLink"
              class="w-full !bg-brand-primary !text-white hover:bg-opacity-90 transition-all font-semibold shadow-md"
            />

            <router-link
              :to="{
                name: 'Login',
                params: $route.params,
                query: $route.query,
              }"
              class="w-full"
            >
              <Button
                icon="left-arrow"
                title="Back to Login"
                type="button"
                class="w-full !bg-white !text-brand-body border border-brand-ash hover:border-brand-primary transition-colors font-medium"
              />
            </router-link>
          </div>

          <div
            class="pt-8 border-t border-brand-ash border-opacity-40 text-center space-y-4"
          >
            <p class="text-brand-body text-sm text-opacity-70">
              Need help? Chat with us using the button below.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Info Column -->
    <InfoColumn />
  </div>
</template>

<script>
import Auth from "@/modules/Auth";
import InfoColumn from "../common/InfoColumn";
import axios1 from "axios";
import { onMounted, ref, computed } from "vue";
import { useRoute } from "vue-router";

export default {
  components: { InfoColumn },
  name: "ExpiredLink",
  setup() {
    const { user, loginWithLink } = Auth();
    const route = useRoute();

    const email = computed(() => route.params.email || route.query.email || "");

    const logo = ref("");
    onMounted(() => {
      axios1.get(process.env.BASE_URL_API + "/logo/get").then((res) => {
        logo.value = res.data;
      });
    });

    const resendLink = () => {
      if (email.value) {
        loginWithLink(email.value);
      }
    };

    return {
      user,
      email,
      logo,
      resendLink,
    };
  },
};
</script>
